import { Header, HeaderActionBack } from "@/components/Header";
import { Layout } from "@/components/Layout";
import styles from "./index.module.scss";

const h1 = "VipPay钱包是一家领先的支付服务创新公司";
type TextItem = { title: string; text: React.ReactNode };
const texts: TextItem[] = [
  {
    title: "我们的使命",
    text: "通过领先的科技和卓越的运营，提供数字化时代的支付处理和账户结算服务，保护客服数据资产安全，持续为客户创造更多的价值。",
  },
  {
    title: "我们的愿景",
    text: (
      <div>
        <p>科技改变支付、支付连接场景、场景沉淀数据、数据创造价值。</p>
        <p>
          VipPay钱包已全面应用云原生技术，并在业内率先构建数字化运营平台，以人工智能、数据技术、区块链等时代前沿技术为基础，建立并发展起核心的交易能力、运营能力和风控能力。目前，VipPay支付交易系统稳定性达到99.9995%。
        </p>
        <p>
          以卓越的运营模式，人性化的关怀服务，为客户创建一个便捷、安全、可靠地支付环境。
        </p>
      </div>
    ),
  },
];
export function PageAboutus() {
  return (
    <Layout
      scrollable
      backgroundImage={false}
      header={<Header title="关于我们" leftActions={<HeaderActionBack />} />}
    >
      <section>
        <div className={styles.bg}>
          <div className={styles.title}>{h1}</div>
          <div className={styles.icon_bg}>
            <div className={styles.logo}></div>
          </div>
        </div>
      </section>

      <section className={styles.h1}>
        <h1>VipPay</h1>
      </section>
      {texts.map((item) => {
        return (
          <section key={item.title} className={styles.content_wrapper}>
            <div className={styles.content_header}>
              <div className={styles.content_header_content}>
                <div className={styles.content_title_left}></div>
                <div className={styles.content_title}>{item.title}</div>
                <div className={styles.content_title_right}></div>
              </div>
            </div>

            <div className={styles.content_text}>{item.text}</div>
          </section>
        );
      })}
    </Layout>
  );
}
